import React, { useRef, useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import InRoomAnnouncementWebController from "./InRoomAnnouncementWebController";
import {
  getInRoomAnnouncementProvider,
  setURL,
} from "./providers/InRoomAnnouncementProvider";
import FloatingPanel from "components/FloatingPanel/FloatingPanel";
import useTileControls from "./hooks/useTileControls";
import {
  inRoomAnnouncementUserJoined,
  inRoomAnnouncementUserLeft,
} from "store/actions/inRoomAnnouncement";

import { inRoomAnnouncementSent } from "store/actions/googleAnalytics";
import { Logger } from "utils/logger";
import { isCustomParamEnabled } from "utils/helpers";
import { getCallAPIProvider } from "services/CallAPIProvider";
import useEventListener from "./hooks/useEventListener";
import showNotification, {
  dismissNotification,
} from "components/Notifications/Notifications";
import announcementIcon from "assets/images/buttons/announcement_notification.svg";
import { useTranslation } from "react-i18next";
const inRoomAnnouncementLogger = new Logger("InRoomAnnouncement");

const InRoomAnnouncementWebWrapper = (props) => {
  const [languageList, setLanguageList] = useState([]);
  const [announcementList, setannouncementList] = useState([]);
  const inRoomannouncementProvider = useRef({});
  const [showAnnouncmentUI, setShowAnnouncmentUI] = useState(false);
  const iconClicked = useSelector(
    (state) => state.inRoomAnnoucement?.iconClicked
  );

  ///////// cc moderation//////////
  const inRoomAnnouncementSubscriptionToken = useRef(null);
  const config = useSelector((state) => state.config);
  const { listOfGCPServices } = useSelector((state) => state.config);
  const customParameters = config.customParameters;
  const participant = useSelector((state) => state.call.participants);
  const participantList = useRef([]);
  const inRoomAnnouncementParticipant = useSelector(
    (state) => state.inRoomAnnoucement?.inRoomAnnouncementParticipants
  );
  const provider = useRef();
  const remoteParticipantsCapabilty = useRef(inRoomAnnouncementParticipant);
  const sendEndpointDiscoveryRequest = useRef(false);
  const localParticpant = useRef(null);
  const RemoteParticpant = useRef([]);
  const isSubscribedCallIntiated = useRef(false);
  const user = useSelector((state) => state.user);
  const call = useSelector((state) => state.call);

  const isUserRegistered = user.isRegistered;
  const isUserAdmin = (user.accountType || "").toLowerCase() === "admin";

  const networkConnectionStatus = useSelector(
    (state) => state.app.networkConnectionStatus
  );
  const callReconnecting = useSelector((state) => state.app.callReconnecting);
  const [isRoomSystemPlayingAudio, setIsRoomSystemPlayingAudio] =
    useState(false);
  const { t } = useTranslation();
  const sentCommandId = useRef(null);
  const isInRoomAnnouncementEnabled = useRef(false);
  const commandSentList = useRef([]);
  const currentNotificationDisplayedUserId = useRef(null);
  //const [isAnnouncementPlaying , setIsAnnouncementPlaying] = useState(false);
  //////////////////////////////////
  const dispatch = useDispatch();
  useTileControls();

  useEffect(() => {
    if(iconClicked){
      props?.toggleSidebar && props.toggleSidebar();
    }
    setShowAnnouncmentUI(iconClicked);
    // eslint-disable-next-line
  }, [iconClicked]);

  const intializeAnnouncement = async () => {
    inRoomannouncementProvider.current = getInRoomAnnouncementProvider();
    const inRoomannouncementConfig =
      await inRoomannouncementProvider.current.getConfiguration();
    await setannouncementList(inRoomannouncementConfig.announcementPrompts);
    let languageList = inRoomannouncementConfig.languageList;
    languageList?.sort(compareLanguage);
    await setLanguageList(languageList);
  };

  const sendAnnouncement = async (language, Prompt) => {
    const particpantId = RemoteParticpant.current?.particpantId;
    const featureId = RemoteParticpant.current?.featureID;
    const featureName = RemoteParticpant.current?.featurName;
    const setValue = { languageId: language.ID, promptText: Prompt.ID };
    const conferenceId = await getConfrenceID();

    const res = await provider.current?.sendCommand(
      conferenceId,
      particpantId,
      featureId,
      featureName,
      setValue,
    );
    inRoomAnnouncementLogger.logInfo(
      "Announcement command sent",
      res?.data?.requestId
    );
    dispatch(inRoomAnnouncementSent(`Announcement Sent for language ${language.value}`));
    const data = {particpantId:particpantId, commandId:(res?.data?.requestId || null)};
    commandSentList.current.push(data);

    remoteParticipantsCapabilty.current.filter((particpant) => { 
      return particpant.particpantId === particpantId;
    }).map((particpant) => {
      particpant.commandId = res?.data?.requestId || null;
      dispatch(inRoomAnnouncementUserJoined(particpant));
      return particpant;
    });
    hideAnnouncementUI();
    announcementSentNotification();
  };

  const getScipId = (id) =>
    id?.substring?.(id.indexOf(":") + 1, id.indexOf(";"));

  const languageSelected = (language) => {
    //selectedInterpreterLanguage(language);
  };

  const announcementPromptSelected = (announcementPrompt) => {
    // setse(announcementPrompt);
  };
  /////////////////////////////////////////// cc moderation data ////////////////////////////
  const renderInRoomAnnouncementButton = (participantId, capabilties) => {
    capabilties.forEach(function (capabilty) {
      if (capabilty.featureKey === "inroom-announcements") {
        inRoomAnnouncementLogger.logInfo(
          `in-room announcement ability  ${capabilty?.enabled}, current value = ${capabilty?.currentValue} , pID = ${participantId}`
        );
        const inRoomAnnouncementCapabilty = {
          isEnable: capabilty?.enabled || false,
          featureID: capabilty?.featureId || null,
          featurName: capabilty?.featureKey || "",
          optionType: capabilty?.options || null,
          currentValue: capabilty?.currentValue || "off",
          particpantId: participantId,
          commandId: null,
          isPlayingAnnoncement: false,
        };
        dispatch(inRoomAnnouncementUserJoined(inRoomAnnouncementCapabilty));
      }
    });
  };
  const triggerCustomEvent = (eventName, data) => {
    const event = new CustomEvent(eventName, { detail: data });
    document.dispatchEvent(event);
  };

  const subscribeForRemoteConfigServiceEvent = useCallback(
    async (localParticipantID, scope = "sender") => {
      let confrenceId = await getConfrenceID();
      try {
        if (user.isGuest) {
          inRoomAnnouncementLogger.logError("User is guest");
          return;
        }
        if (!customParameters) {
          inRoomAnnouncementLogger.logError(
            "PortalCustomParameters is not available"
          );
          return;
        }

        let isInRoomAnnouncementDisabledInPortal = !isCustomParamEnabled(
          isUserRegistered
            ? customParameters?.isInRoomAnnouncementFeatureSupported || false
            : false
        );
        if (isInRoomAnnouncementDisabledInPortal) {
          isInRoomAnnouncementEnabled.current = false;
          inRoomAnnouncementLogger.logError(
            "Feature is disabled in custom parameters"
          );
          return;
        }
        isInRoomAnnouncementEnabled.current = true;
        const remoteConfigurationService =
          listOfGCPServices?.remoteConfigurationService || null;

        if (
          remoteConfigurationService === null ||
          !remoteConfigurationService?.url ||
          !remoteConfigurationService?.isServiceAvailable
        ) {
          inRoomAnnouncementLogger.logError(
            "listOfGCPServices remoteConfigurationService configuration is wrong"
          );
          return;
        }

        const inRoomAnnouncementService =
          listOfGCPServices?.inRoomAnnouncementService || null;
        if (
          inRoomAnnouncementService === null ||
          !inRoomAnnouncementService?.url ||
          !inRoomAnnouncementService?.isServiceAvailable
        ) {
          inRoomAnnouncementLogger.logError(
            "listOfGCPServices inRoomAnnouncementService configuration is wrong"
          );
          return;
        }
        setURL(remoteConfigurationService.url, inRoomAnnouncementService?.url);
        intializeAnnouncement();
      } catch (error) {
        inRoomAnnouncementLogger.logError("initialization failed", error);
      }
      const getTokenAndSubscribe = () => {
        if (!confrenceId && !localParticipantID) {
          inRoomAnnouncementLogger.logError(
            "no confrence id found  or no local particpant id found"
          );
          return;
        }
        provider.current = getInRoomAnnouncementProvider();
        provider.current
          .getSubscriptionToken(confrenceId, localParticipantID, scope)
          .then((data) => {
            inRoomAnnouncementSubscriptionToken.current =
              data.data.subscriptionToken || null;
            if (inRoomAnnouncementSubscriptionToken.current) {
              provider.current
                .subscribeToTopic(
                  inRoomAnnouncementSubscriptionToken.current,
                  handleCCModerationMessage,
                  statusCallback
                )
                .catch((e) =>
                  inRoomAnnouncementLogger.logError(
                    `Error while subscribe on sender`,
                    JSON.stringify(e)
                  )
                );
            } else {
              inRoomAnnouncementLogger.logInfo(
                `Can't get token for cc moderation sender`
              );
            }
          })
          .catch((e) => {
            inRoomAnnouncementLogger.logError(
              "Error while getting subscription token for cc moderation",
              JSON.stringify(e?.error)
            );
          });
      };

      const statusCallback = (status, message, code) => {
        inRoomAnnouncementLogger.logInfo(
          `Subscription on cc moderatrion. Status = ${status}, message = ${message}, code = ${code}`
        );

        if (status === "SUBSCRIPTION_SUBSCRIBED") {
          sendEndpointDiscoveryRequest.current = false;
          window.setTimeout(sendFeatureDiscoveryRequest, 10000);
        }

        if (status === "SUBSCRIPTION_INOPERATIVE") {
          inRoomAnnouncementSubscriptionToken.current = null;
          getTokenAndSubscribe();
        } else if (status === "SUBSCRIPTION_ERROR") {
          inRoomAnnouncementSubscriptionToken.current = null;
          getTokenAndSubscribe();
        }
      };

      const handleCCModerationMessage = (message) => {
        messageRecieved(message);
        triggerCustomEvent("roomConfigurationMessageRecieved", {
          detail: message,
        });
      };

      getTokenAndSubscribe();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const clearAnnouncementSentNotification = () => {
    if (window.announcementSent) {
      dismissNotification(window.announcementSent);
      window.announcementSent = null;
    }
  };
  const clearAudioPlayingNotification = () => {
    if (window.audioPlaying) {
      dismissNotification(window.audioPlaying);
      window.audioPlaying = null;
    }
  };

  const clearAudioPlayedNotification = () => {
    if (window.audioPlayed) {
      dismissNotification(window.audioPlayed);
      window.audioPlayed = null;
    }
  };

  const clearAudioPlayingErrorNotification = () => {
    if (window.audioPlayingError) {
      dismissNotification(window.audioPlayingError);
      window.audioPlayingError = null;
    }
  };

  const clearNotifications = () => {
    clearAudioPlayingNotification();
    clearAudioPlayingErrorNotification();
    clearAnnouncementSentNotification();
    clearAudioPlayedNotification();
  };

  const announcementSentNotification = (message = "") => {
    if (window.announcementSent) {
      return;
    }
    clearNotifications();
    window.announcementSent = showNotification("banner", {
      message: t("ANNOUNCEMENT_SENT"),
      icon: announcementIcon,
      showFor: -1,
    });
  };

  const announcementPlayingNotification = (message = "") => {
    if (window.audioPlaying) {
      return;
    }
    clearNotifications();
    window.audioPlaying = showNotification("banner", {
      message: t("ANNOUNCEMENT_PLAYING"),
      icon: announcementIcon,
      showFor: -1,
    });
  };

  const announcementPlayedNotification = (message = "") => {
    if (window.audioPlayed) {
      return;
    }
    clearNotifications();
    window.audioPlayed = showNotification("banner", {
      message: t("ANNOUNCEMENT_PLAYED"),
      icon: announcementIcon,
      showFor: 5000,
    });
  };

  const announcementAudioErrorNotification = (message = "") => {
    if (window.audioPlayingError) {
      return;
    }
    clearNotifications();
    window.audioPlayingError = showNotification("banner", {
      message: t("ANNOUNCEMENT_FAILED"),
      icon: announcementIcon,
      showFor: -1,
    });
  };

  const setAnnoncementPlayingState = (participantId, isPlaying) => {
    remoteParticipantsCapabilty.current.forEach((particpant) => {
      if (particpant.particpantId === participantId) {
        particpant.isPlayingAnnoncement = isPlaying;
        dispatch(inRoomAnnouncementUserJoined(particpant));
      }
    });
  };

    const isCommandSentByCurrentUser = (commandId) => {
      const isPresent = commandSentList.current.find(
        (data) => data.commandId === commandId
      );
      return isPresent ? true : false;
    };

  const messageRecieved = (message) => {
    if(!isInRoomAnnouncementEnabled.current){
        inRoomAnnouncementLogger.logInfo("in room announcement is disabled");
        return;
      }
    const MessageContent = JSON.parse(message || "");
    const data = MessageContent?.data || null;
    inRoomAnnouncementLogger.logInfo(
      `recieved message from event server ${MessageContent.eventType}, pID = ${data?.participantScipId}`
    );
    if (MessageContent.eventType === "remote-feature-register-request") {
      const remoteParticipantId = data.participantScipId;
      const capabilties = data.remoteCapabilities;
      renderInRoomAnnouncementButton(remoteParticipantId, capabilties);
    }
    if (MessageContent.eventType === "remote-feature-register-request-global") {
      const remoteFeatures = data.remoteFeatures;
      remoteFeatures.forEach(function (feature) {
        const remoteParticipantId = feature.participantScipId;
        const capabilties = feature.remoteCapabilities;
        renderInRoomAnnouncementButton(remoteParticipantId, capabilties);
      });
    }
    if (MessageContent.eventType === "remote-feature-status-request") {
      const featureName = data?.featureKey || "";
      inRoomAnnouncementLogger.logInfo(
        "remote-feature-status-request recieved for ",
        featureName
      );
      if (featureName === "inroom-announcements") {
        const commandId = data?.commandRequestId || null;
        const values = data?.value ? JSON.parse(data?.value) : null;
        const audioPlayingState = values?.playbackStatus || null;
        const participantId = data?.participantScipId || null;
        inRoomAnnouncementLogger.logInfo(
          `remote-feature-status-request recieved for ${featureName} command id ${commandId} audioPlayingState ${audioPlayingState}`
        );
          switch (audioPlayingState) {
            case "playing":
              setAnnoncementPlayingState(participantId, true);
              if(isCommandSentByCurrentUser(commandId)){
              currentNotificationDisplayedUserId.current = participantId;
              announcementPlayingNotification();
              }
              setIsRoomSystemPlayingAudio(true);
              break;
            case "Completed":
              setAnnoncementPlayingState(participantId, false);
              if(isCommandSentByCurrentUser(commandId)){
              currentNotificationDisplayedUserId.current = participantId;
              announcementPlayedNotification();
              }
              sentCommandId.current = null;
              setIsRoomSystemPlayingAudio(false);
              break;
            case "Error":
              setAnnoncementPlayingState(participantId, false);
              if(isCommandSentByCurrentUser(commandId)){
              currentNotificationDisplayedUserId.current = participantId;
              announcementAudioErrorNotification();
              }
              sentCommandId.current = null;
              setIsRoomSystemPlayingAudio(false);
              break;
            default:
              break;
          }
        }
    }
  };
  useEffect(() => {
    remoteParticipantsCapabilty.current = inRoomAnnouncementParticipant;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inRoomAnnouncementParticipant]);

  const clearData = useCallback(() => {
    inRoomAnnouncementLogger.logInfo("Clear desktop component data");
    if (inRoomAnnouncementSubscriptionToken.current) {
      provider.current?.unsubscribeFromTopic(
        inRoomAnnouncementSubscriptionToken.current
      );
      inRoomAnnouncementSubscriptionToken.current = null;
      sendEndpointDiscoveryRequest.current = false;
      provider.current = null;
      remoteParticipantsCapabilty.current = [];
      localParticpant.current = null;
      RemoteParticpant.current = [];
      isSubscribedCallIntiated.current = false;
      clearNotifications();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sendFeatureDiscoveryRequest = async () => {
    if (!sendEndpointDiscoveryRequest.current) {
      sendEndpointDiscoveryRequest.current = true;
      const confrenceId = await getConfrenceID();

      const remoteSCIPIds = [];

      participantList.current.map((data) => {
        remoteSCIPIds.push(getScipId(data.id));
        return data;
      });
      if (confrenceId && remoteSCIPIds.length > 0) {
        provider.current?.featureDiscovery(confrenceId, remoteSCIPIds);
        inRoomAnnouncementLogger.logInfo(`feature discovery request sent`);
      }
    }
  };

  const getConfrenceID = async () => {
    let confrenceId = null;
    const vidyoConnector =
      getCallAPIProvider().vidyoConnector || getCallAPIProvider().vidyoEndpoint;
    const statsJson = await vidyoConnector.GetStatsJson();
    const data = JSON.parse(statsJson);
    if (data.userStats[0].roomStats.length) {
      // filter not active rooms that for some reson may be present in statistic
      const filteredRoomsStats = data.userStats[0].roomStats.filter(
        (roomData) => {
          return (
            roomData && roomData.participantStats.length && roomData.callId
          );
        }
      );
      confrenceId = filteredRoomsStats.length
        ? filteredRoomsStats[0].conferenceId
        : null;
    }
    return confrenceId;
  };

  useEventListener("inRoomAnnouncementClicked", ({ detail }) => {
    RemoteParticpant.current = detail;
    props?.toggleSidebar && props.toggleSidebar();
    displayAnnouncementPanel();
  });

  useEventListener("roomConfigurationMessageRecieved", ({ detail }) => {
    console.log(`on roomConfigurationMessageRecieved button for `, detail);
    messageRecieved(detail);
  });

  useEffect(() => {
    inRoomAnnouncementLogger.logInfo("Component initialized");
    return () => {
      inRoomAnnouncementLogger.logInfo("Component UnInitialized");
      clearData();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function compareLanguage(a, b) {
    if (a.value < b.value) {
      return -1;
    }
    if (a.value > b.value) {
      return 1;
    }
    return 0;
  }

   useEffect(() => {
    if (participant?.list.length > 0 && !isSubscribedCallIntiated.current) {
      for (let particpantData of participant.list) {
        const isUserRoomOwner =
          user.userInfo?.entityID &&
          call.roomInfo?.ownerID &&
          user.userInfo?.entityID === call.roomInfo?.ownerID;
        if (
          particpantData.isLocal &&
          isUserRegistered &&
          (isUserRoomOwner || isUserAdmin || user.becomeModerator)
        ) {
          isSubscribedCallIntiated.current = true;
          subscribeForRemoteConfigServiceEvent(getScipId(particpantData.id));
          window.setTimeout(sendFeatureDiscoveryRequest, 6000);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [participant, call.roomInfo?.ownerID, user.becomeModerator]);

  useEffect(() => {
    participantList.current = participant?.list;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [participant]);

  useEffect(() => {
    if (participant?.participantLeft) {
      inRoomAnnouncementLogger.logInfo(
        `particpant leave the conference pID = ${participant.participantLeft.id}`
      );
      if (
        RemoteParticpant.current?.particpantId ===
        getScipId(participant.participantLeft.id)
      ) {
     hideAnnouncementUI();
      dispatch(
        inRoomAnnouncementUserLeft(getScipId(participant.participantLeft.id))
      );
    }
    if(currentNotificationDisplayedUserId.current && currentNotificationDisplayedUserId.current === getScipId(participant.participantLeft.id)){
        clearNotifications();
    }
  }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [participant.participantLeft]);

  useEffect(() => {
    if (!networkConnectionStatus || callReconnecting) {
      isSubscribedCallIntiated.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [networkConnectionStatus, callReconnecting]);

    const getCurrentPlayingStatusOfAnnouncement = () => {
    
    const particpantId = RemoteParticpant.current?.particpantId || null;
    const data = remoteParticipantsCapabilty.current.find((particpant) => {
      return particpant?.particpantId === particpantId;
    });
    if(data){
      return data?.isPlayingAnnoncement || false;
    }
    return false;
  }


 const displayAnnouncementPanel = useCallback(() =>{
    setShowAnnouncmentUI(true);
    const particpantId = RemoteParticpant.current?.particpantId || null;
    const data = remoteParticipantsCapabilty.current.find((particpant) => {
      return particpant?.particpantId === particpantId;
    }) || {};
    data.isVisble = true;
    dispatch(inRoomAnnouncementUserJoined(data));
// eslint-disable-next-line
  },[]);

  const hideAnnouncementUI = useCallback(() => {
    setShowAnnouncmentUI(false);
    const particpantId = RemoteParticpant.current?.particpantId || null;
    const data = remoteParticipantsCapabilty.current.find((particpant) => {
      return particpant?.particpantId === particpantId;
    }) || {};
    data.isVisble = false;
    dispatch(inRoomAnnouncementUserJoined(data));
    // eslint-disable-next-line
  },[]);


  if (showAnnouncmentUI) {
    return (
      <FloatingPanel
        title={""}
        isMinimizable={false}
        isDraggable={false}
        className="announcement-panel"
        onClose={() => {
          hideAnnouncementUI();
        }}
        content={
          <InRoomAnnouncementWebController
            languageList={languageList}
            sendAnnouncement={sendAnnouncement}
            announcementList={announcementList}
            languageSelected={languageSelected}
            announcementSelected={announcementPromptSelected}
            isAnnouncementPlaying={getCurrentPlayingStatusOfAnnouncement()}
            hideAnnouncementUI={ () => { hideAnnouncementUI()} }
            isPlaying={isRoomSystemPlayingAudio}

          />
        }
      ></FloatingPanel>
    );
  }
};

export default InRoomAnnouncementWebWrapper;
